<template>
    <div class="requests page-wrapper">
        <div class="requests-inner">
            <div class="requests-inner-list">
                <div class="requests-inner-list-header">
                  <div>Request History</div>
                  <div>{{ this.$store.state.user.first_name + ' ' + this.$store.state.user.last_name }}</div>
                </div>
                <div class="requests-inner-list" v-loading="loading">
                    <div v-for="(request, index) in requestsData" :key="request.id" :class="{'requests-inner-list-item': true, 'active': expanded === request.id}" >
                        <div :class="{'requests-inner-list-item-header': true, first: index === 0}" @click="expand(request)">
                            <div class="request-id">
                                {{ request.id }}
                            </div>
                            <div class="request-status">
                              <template v-if="request.orderItems.length > 1">
                                {{ request.orderItems.length }} items
                              </template>
                              <template v-else>
                                {{ request.orderItems.length }} item
                              </template>
                            </div>
                            <div class="request-date">
                                {{ request.created_at | formatDate }}
                            </div>
                        </div>
                        <div class="requests-inner-list-item-content" v-if="expanded === request.id">
                          <div v-if="request.orderItems.length === 0" class="requests-inner-list-item-content-items" >
                            no items
                          </div>
                            <div v-else-if="typeof request.items === 'undefined'" v-loading="request.loading" class="requests-inner-list-item-content-items" >
                              <span></span>
                            </div>
                            <template v-else>
                                <div v-for="item in request.items" class="requests-inner-list-item-content-items" :key="item.id">
                                    <div class="requests-inner-list-item-content-items-image" @click="$router.push('/products/' + item.id)" >
                                      <img :src="getbase64EncodedImage(item.attributes)"/>
                                    </div>
                                    <div class="item-filename">
                                        {{ item.attributes.Filename[0] }}
                                    </div>
                                    <div class="item-status">
                                      {{ request.orderItems.find(function (object) { return object.asset_id === item.id}).status }}
                                    </div>
                                </div>
                                <div v-for="n in request.orderItems.length - request.items.length" class="requests-inner-list-item-content-items" :key="request.id + '_deleted_' + n">
                                  <div class="requests-inner-list-item-content-items-image"></div>
                                  <div class="item-filename">removed from extensis</div>
                                </div>
                            </template>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { HTTP } from '@/services/api'

export default {
  name: 'Requests',
  data () {
    return {
      loading: false,
      expanded: null,
      requestsData: [],
      pagination: {
        page: 1,
        perPage: process.env.VUE_APP_ORDERS_PAGINATION_SIZE || 40
      },
      hasMore: true,
      scrollLoading: false
    }
  },
  created () {
    window.addEventListener('scroll', this.scroll)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.scroll)
  },
  mounted () {
    this.loadRequests()
  },
  watch: {
    'pagination.page' () {
      if (!this.loading) {
        this.loadRequests()
      }
    }
  },
  methods: {
    handleScroll () {
      let bottomOfWindow = (Math.ceil(Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop) + window.innerHeight) + 10) > Math.ceil(document.documentElement.offsetHeight)
      if (bottomOfWindow && !this.scrollLoading && !this.loading && this.hasMore) {
        this.scrollLoading = true
        this.pagination.page = this.pagination.page + 1
      }
    },
    debounce (method, delay) {
      clearTimeout(method._tId)
      method._tId = setTimeout(function () {
        method()
      }, delay)
    },
    scroll () {
      this.debounce(this.handleScroll, 300)
    },
    expand (item) {
      if (this.expanded === item.id) {
        this.expanded = null
        return
      }
      this.expanded = item.id
      this.loadItems(item)
    },
    getbase64EncodedImage (item) {
      if (typeof item['com.extensis.portfolio.Preview'] !== 'undefined') {
        return 'data:image/jpeg;base64,' + item['com.extensis.portfolio.Preview'][0].replace(/(\r\n|\n|\r)/gm, '')
      } else if (typeof item['Thumbnail'] !== 'undefined') {
        return 'data:image/jpeg;base64,' + item['Thumbnail'][0].replace(/(\r\n|\n|\r)/gm, '')
      }
    },
    loadRequests () {
      this.loading = true
      HTTP({
        method: 'GET',
        url: '/api/v1/users/orders',
        params: this.pagination,
        crossdomain: true
      })
        .then(response => {
          if (response.data.data) {
            this.requestsData = this.requestsData.concat(response.data.data)
            if (response.data.data.length === 0) {
              this.hasMore = false
            }
          }
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        }).finally(() => {
          setTimeout(() => {
            this.scrollLoading = false
          }, 500)
        })
    },
    loadItems (item) {
      if (typeof item.items !== 'undefined' || item.loading) {
        return
      }

      this.$set(item, 'loading', true)

      let assetIds = item.orderItems.map(function (item) { return item.asset_id })
      if (assetIds.length) {
        HTTP({
          method: 'GET',
          url: '/api/v1/assets/ids',
          params: {
            ids: assetIds
          },
          crossdomain: true
        })
          .then(response => {
            if (response.data.data) {
              this.$set(item, 'items', response.data.data.assets)
            }
            this.$set(item, 'loading', false)
          })
          .catch(() => {
            this.$set(item, 'loading', false)
          })
      }
    }
  }
}
</script>
